import React, {useEffect, useState} from "react";
import {Draggable, Droppable} from "react-beautiful-dnd";
import {
    ASCII_CODE_A,
    MC_ANSWER_LENGTH,
    RESPONSE_TITLE,
} from "../../utils/constants";
import {stripHTMLTags} from "../../utils/helpers";

import "../styles.css";
import {convertMHOptionMap} from "../../utils/questionUtils";
import {EditorContent, useEditor} from "@tiptap/react";
import Underline from "@tiptap/extension-underline";
import StarterKit from "@tiptap/starter-kit";
import Placeholder from "@tiptap/extension-placeholder";
import CharacterCount from "@tiptap/extension-character-count";
import {Color} from "@tiptap/extension-color";
import TextStyle from "@tiptap/extension-text-style";
import Highlight from "@tiptap/extension-highlight";
import {ReactComponent as TOGGLE} from "../../images/font_gray.svg";
import {ReactComponent as DRAG} from "../../images/drag_flat_grey.svg";
import {ReactComponent as DELETE} from "../../images/trash_red.svg";
import classes from "../questions.module.css";
import {TipTapMenuBarNew} from "../../components/Tiptap/TipTapMenuBarNew";
import TiptapClasses from "../../components/Tiptap/Tiptap.module.css";
import { useTranslation } from "react-i18next";


export default function ResponseNew({
                                        idPrefix,
                                        optionData,
                                        selectedQuestion,
                                        questions,
                                        setQuestions,
                                        index,
                                        questionBuilder = false,
                                        disabled = false,
                                        handleDeleteOption,
                                        collapsed,
                                        setCollapsed,
                                    }) {
    const { t } = useTranslation();
    const {serialNo, correctAnswers} = selectedQuestion;
    const selectedQuestionIndex = serialNo - 1;

    const handleAnswerChange = (input, index) => {
        let copyOfQuestions = JSON.parse(JSON.stringify(questions));
        let newCorrectAnswers = copyOfQuestions[selectedQuestionIndex].correctAnswers;
        if (newCorrectAnswers[index].length > 1) {
            newCorrectAnswers[index][1] = input;
        } else {
            newCorrectAnswers[index][0] = input;
        }
        copyOfQuestions[selectedQuestionIndex].correctAnswers = newCorrectAnswers;
        if (!!questionBuilder) {
            copyOfQuestions[selectedQuestionIndex].optionsMap = convertMHOptionMap(newCorrectAnswers);
        }
        setQuestions(copyOfQuestions);
    };


    const editor = useEditor({
        shouldRerenderOnTransaction: true,
        editorProps: {
            transformPastedHTML(text) {
                return stripHTMLTags(text);
            },
        },
        extensions: [
            Underline,
            StarterKit,
            Placeholder.configure({
                placeholder: t("questionBuilder.enterResponseText") + " " + (index + 1),
            }),
            CharacterCount.configure({limit: MC_ANSWER_LENGTH}),
            TextStyle,
            Color,
            Highlight,
            // Mathematics.configure({
            //   regex: LATEX_REG_EXP,
            // }),
        ],
        onUpdate: ({editor}) => {
            handleAnswerChange(editor.getHTML(), index);
        },
        content: !!optionData ? (optionData.length > 1 ? optionData[1] : optionData[0]) : "",
    }, [serialNo]);


    useEffect(() => {
        let val = optionData ? (correctAnswers[index].length > 1 ? optionData[1] : optionData[0]) : "";
        if (val !== editor.getHTML()) {
            editor.commands.setContent(val);
        }

    }, [correctAnswers, optionData, editor]);


    const renderIndexAndImage = (dragHandleProps) => {
        return (
            <span {...dragHandleProps}  style={{marginLeft: 12}}>
                <DRAG/>
            </span>
        );
    }


    const renderOptionManageBar = (index) => {
        return (
            <div style={{display: "flex", gap: 5, alignItems: "center", paddingRight: 12}}>
                <span
                    tabIndex={0}
                    style={{cursor: "pointer",}}
                    title={t("poll.toggleMenuBarText")}
                    onClick={() => setCollapsed(!collapsed)}
                >
                    <TOGGLE/>
                </span>
                {correctAnswers.length > 2 &&
                    <>
                        <span className={classes.iconDivider}/>
                        <span
                            tabIndex={0}
                            style={{cursor: "pointer",}}
                            title={t("accessibility.deleteOptionButtonPrefix")}
                            onClick={() => handleDeleteOption(index)}
                        >
                           <DELETE/>
                        </span>
                    </>
                }

            </div>
        );
    }


    return (
        <Droppable droppableId={idPrefix + index}>
            {(provided, snapshot) => (
                <div
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    {...provided.dropHandleProps}
                    className={classes.MHRightContainer}
                    style={{display: "unset"}}
              >

                    <Draggable
                        draggableId={"response draggable "+ index}
                        index={index}
                        isDragDisabled={questionBuilder && disabled}
                    >
                      {(provided) => (
                          <div
                              tabIndex={-1}
                              className={classes.optionBarWrapper}
                              style={{background: "#FFFFFF"}}
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                          >
                              <div className={classes.optionBar}>
                                  {!!collapsed && renderIndexAndImage(provided.dragHandleProps)}
                                  <span className={classes.optionEditorWrapper}>
                                        <div
                                            className={`${classes.optionEditorMenuBar} ${collapsed ? classes.collapsed : ""}`}>
                                            <TipTapMenuBarNew
                                                isOpen={!collapsed}
                                                editor={editor}
                                                selectedQuestion={selectedQuestion}
                                            />
                                            {!collapsed && renderOptionManageBar(index)}
                                        </div>
                                        <div style={{display: "flex", gap: 10, alignItems: "center"}}>
                                            {!collapsed && renderIndexAndImage(provided.dragHandleProps)}
                                            <EditorContent
                                                editor={editor}
                                                style={{cursor: "text", flex: 1, minWidth: 0, height: "100%", paddingRight: collapsed ? 10 : undefined}}
                                                className={`${TiptapClasses.editorContentBox} ${collapsed ? TiptapClasses.noneOutLine : ""}`}
                                            />
                                        </div>


                                      {(!collapsed || (!!editor.isFocused && editor.storage.characterCount.characters() > 0)) &&
                                          <span
                                              className={`${classes.characterCountBox} ${collapsed ? classes.inline : ""}`}>
                                                {collapsed
                                                    ? editor.storage.characterCount.characters()
                                                    : `${editor.storage.characterCount.characters()}/${MC_ANSWER_LENGTH}`
                                                }
                                            </span>
                                      }
                                    </span>
                                  {!!collapsed && renderOptionManageBar(index)}
                              </div>
                          </div>
                      )}
                    </Draggable>

                  { provided.placeholder}

              </div>
          )}
        </Droppable>
    );
}